<div
  class="text-text-primary relative grid size-20 rounded-full border-4 border-slate-300 bg-white drop-shadow-md"
  [class]="direction() === 'LEFT' ? '-scale-x-100' : undefined"
>
  <i-chevron />
</div>
